import { useMutation } from 'react-query'
import { useAuth0 } from '../../contexts/auth0-context'
import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'

type UseUpdateDraftMutationProps = {
    onSuccess?: () => void
    onError?: (error: unknown) => void
}

type UpdateDraftVariables = {
    draftId: string
    fields: Record<string, unknown>
}

export const useUpdateDraftMutation = ({ onSuccess, onError }: UseUpdateDraftMutationProps = {}) => {
    const { getTokenSilently, isAuthenticated } = useAuth0()

    const updateDraft = async ({ draftId, fields }: UpdateDraftVariables) => {
        if (!isAuthenticated) throw new Error('User must be authenticated to update a draft')

        const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
        if (!token) throw new Error('Failed to get authentication token')

        const response = await callAPI(endpoints.updateDraft.url + draftId, endpoints.updateDraft.method, token, fields)

        if (!response.success) throw new Error(response.error || 'Failed to update draft')

        return response
    }

    return useMutation(updateDraft, {
        onSuccess: () => onSuccess?.(),
        onError: (error) => {
            console.error('Error updating draft:', error)
            onError?.(error)
        },
    })
}
